// History queries cover calendar months; day navigation within the same month
// does not change the Firestore result set.
export function calendarQueryMonth(value, fallback = new Date()) {
  const date = value instanceof Date && Number.isFinite(value.getTime()) ? value : fallback;
  return `${date.getFullYear()}-${date.getMonth()}`;
}
